






































import { namespace } from 'vuex-class';
import { Vue, Component, Prop } from 'vue-property-decorator';

import Modal from '@/shared/components/Modal/Modal.vue';
import RadioBox from '@/shared/components/RadioBox/RadioBox.vue';
import EarlyRenewal from '@/shared/components/EarlyRenewal/EarlyRenewal.vue';
import ScreenSizeVisibility from '@/shared/components/ScreenSizeVisibility/ScreenSizeVisibility.vue';

import PixContent from './PixContent.vue';
import PaymentActions from '../../../PaymentActions/PaymentActions.vue';

import { EPaymentMethodTypes, EPaymentMethod } from '@/helpers/enums';

import { Payment } from '@/classes/Checkout/Payment';

const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    Modal,
    RadioBox,
    EarlyRenewal,
    PaymentActions,
    PixContent,
    ScreenSizeVisibility,
  },
})
export default class Pix extends Vue {
  @Prop()
  private readonly type?: EPaymentMethodTypes;

  @Prop()
  private readonly active?: boolean;

  @Prop()
  private readonly isUpsell!: boolean;

  @Prop()
  private readonly validatePaymentType!: Function;

  @CheckoutModule.Getter('selectedOfferPayment')
  private readonly payment!: Payment;

  @CheckoutModule.State
  private readonly modalPayment!: boolean;

  @CheckoutModule.Mutation
  private readonly toggleModalPayment!: Function;

  @CheckoutModule.Getter('isRenewal')
  private isRenewal: boolean;

  private get isMobile () {
    return this.$vuetify.breakpoint.smAndDown;
  }

  private get wrapper () {
    return this.isMobile
      ? 'Modal'
      : 'div';
  }

  private get pix () {
    return this.payment.getPaymentMethod(EPaymentMethod.pix);
  }

  private get paymentTypeSelected () {
    return this.payment.selectedPaymentType;
  }

  private get paymentTypes () {
    return EPaymentMethodTypes;
  }
}
